export default function translate(i18n, propriete) {
  const baseKey = 'editionCommande.logistiqueImpression.affiches.table';
  if (propriete.includes('Commentaire')) {
    return i18n.t(`${baseKey}.commentaire`);
  }
  return propriete;
}
